import React from "react";
import axios from "axios";

export const getAllFaqsApi = async () => {
  try {
    let url = "https://visapro-api.tcore.online/api/v1/faqs/question_types";

    const response = await axios.get(url);
    const faqs = {
      data: response.data,
    };
    return faqs;
  } catch (error) {
    const faqs = {
      error: error,
    };
    return faqs;
  }
};
